import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Phase 0 — canonical `cn` utility used across shadcn primitives and the
 * new rc/ui components. Merges conditional clsx inputs with tailwind-merge
 * so later class strings correctly override earlier ones (e.g. `cn("p-2",
 * expanded && "p-4")` yields `p-4` without both `p-*` utilities landing on
 * the element).
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
